import { defineComponent } from "vue"

export default defineComponent({
  render() {
    return null
  },
})
